import styled from '@emotion/styled';
import { forwardRef } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { MenuItem } from './PDFDownload';

const StyledSkeleton = styled(Skeleton)`
  background-color: var(--color-divider);
`;

const StyledOvalSkeleton = styled(StyledSkeleton)`
  border-radius: 6px;
`;

const MenuItemLoadingState = ({ width }) => (
  <MenuItem>
    <StyledSkeleton
      animation={false}
      variant="circle"
      width="20px"
      height="20px"
    />
    <StyledOvalSkeleton
      animation={false}
      variant="text"
      width={width}
      height="14px"
    />
  </MenuItem>
);

const MenuLoader = forwardRef(function MenuLoader(_, ref) {
  return (
    <div ref={ref}>
      <MenuItem>
        <StyledOvalSkeleton
          animation={false}
          variant="text"
          width="105px"
          height="20px"
        />
      </MenuItem>
      <MenuItemLoadingState width="105px" />
      <MenuItemLoadingState width="85px" />
      <MenuItemLoadingState width="65px" />
      <MenuItemLoadingState width="45px" />
    </div>
  );
});

export default MenuLoader;
